  document.querySelectorAll('.bundel_label input[type="radio"]').forEach(input => {
  input.addEventListener('change', function() {
    document.querySelectorAll('.bundel_label').forEach(label => {
      label.classList.remove('checked');
    });
    if (input.checked) {
      input.closest('.bundel_label').classList.add('checked');
    }
  });
});


const soloDiscountedPrice = document.querySelector('.bundleCost[data-bundletype="solo"]');
const soloCompareAtPrice = document.querySelector('.bundleCompareAtCost[data-bundletype="solo"]');

  const bundleSelectionDuo = document.getElementById('bundle-selection-duo');
  const bundleSelectionTrio = document.getElementById('bundle-selection-trio');
  const bundleSelectionSolo = document.getElementById('bundle-selection-solo');

  const addToCartButton = document.getElementById('custom-add-to-cart');
  const klarnaset = document.getElementById('klarnaset');
  const atcPriceSec = document.getElementById('atc-price-sec');
  const arkRegPrice = document.getElementById('arkRegPrice');
  const arkSalePrice = document.getElementById('arkSalePrice');
  const savePrice = document.getElementById('savePrice');
  
function getVariantId() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (!variantId) {
        var bundleOptions = document.getElementById('bundle-options');
        if (bundleOptions) {
            variantId = bundleOptions.getAttribute('data-frist-id');
        }
    }
    return variantId;
}

  function fetchAndDisplayVariantById(variantId) {
    var variantUrl = `/variants/${variantId}.js`;
    fetch(variantUrl)
        .then(response => response.json())
        .then(variant => {
            // Update the DOM or perform other actions with the variant data here
            soloDiscountedPrice.innerHTML = (variant.price / 100).toFixed(2) + " €";
            savePrice.classList.add("hidden");
            if (variant.compare_at_price){
              soloCompareAtPrice.innerHTML = (variant.compare_at_price / 100).toFixed(2) + " €";
            }
            arkSalePrice.innerHTML = (variant.price / 100).toFixed(2) + " €";
            klarnaset.innerHTML = ((variant.price / 100)/3).toFixed(2) + " €";
            if (variant.compare_at_price){
              arkRegPrice.innerHTML = (variant.compare_at_price / 100).toFixed(2) + " €";
              // klarnaset.innerHTML = ((variant.compare_at_price / 100)/3).toFixed(2) + " €";
            } else {
              arkRegPrice.innerHTML = '';
              // klarnaset.innerHTML = '';
            }
          
          if(variant.available){
            addToCartButton.disabled = false
          } else {
            addToCartButton.disabled = true
          }

            // Render the options for the solo bundle type
            renderSoloOptions(variant.options);
        })
        .catch(error => console.error('Error fetching variant data:', error));
}

function renderSoloOptions(variantOptions) {

    bundleSelectionSolo.innerHTML = ''; // Clear any existing options

    const optionDiv = document.createElement('div');
    optionDiv.classList.add('bundle-option');

    productOptions.forEach((option, index) => {
        const select = document.createElement('select');
        select.name = `option-0-${option.name}`;

        option.values.forEach(value => {
            const optionElement = document.createElement('option');
            optionElement.value = value;
            optionElement.textContent = value;
            optionElement.setAttribute('data-bundleType', 'solo');
            select.appendChild(optionElement);

            // Set the default selected option
            if (value === variantOptions[index]) {
                optionElement.selected = true;
            }

            if (value === "Default Title") {
                optionElement.parentElement.setAttribute('hidden', 'hidden');
            }
        });

        optionDiv.appendChild(select);
    });

    bundleSelectionSolo.appendChild(optionDiv);
}


function handleVariantChange() {
    var variantId = getVariantId();
    if (variantId) {
        fetchAndDisplayVariantById(variantId);
    }
}

    handleVariantChange();
    const productViewVariants = document.querySelector('.productView-variants');
     if (productViewVariants){
        productViewVariants.addEventListener('change', function() {
         handleVariantChange();
        });
     }

  
document.addEventListener('DOMContentLoaded', function(){ 
  handleVariantChange();
  
const bundleOptions = document.getElementById('bundle-options');
  const duoDiscount = bundleOptions.dataset.duodiscount;
  const trioDiscount = bundleOptions.dataset.triodiscount;


function renderOptions(bundleType) {
  
  if (bundleType == 'duo' || bundleType == 'trio') {
     bundleSelectionSolo.innerHTML = '';
  }else{

    handleVariantChange();
  }

  // Hide all bundle selection divs
  // bundleSelectionSolo.innerHTML = '';
  bundleSelectionDuo.innerHTML = '';
  bundleSelectionTrio.innerHTML = '';

  let numberOfSelections = 1;
  let currentSelectionDiv = bundleSelectionSolo;
  if (bundleType === 'duo') {
    numberOfSelections = 2;
    currentSelectionDiv = bundleSelectionDuo;
  }
  if (bundleType === 'trio') {
    numberOfSelections = 3;
    currentSelectionDiv = bundleSelectionTrio;
  }

  // Render the options into the relevant div
  if (bundleType !== 'solo') {
  for (let i = 0; i < numberOfSelections; i++) {
    const optionDiv = document.createElement('div');
    optionDiv.classList.add('bundle-option');
    const label = document.createElement('div');
    label.textContent = `Produit ${i + 1}`;
    label.style.fontWeight = '500';
    label.style.fontSize = '14px';
    optionDiv.appendChild(label);

    productOptions.forEach(option => {
      const select = document.createElement('select');
      select.name = `option-${i}-${option.name}`;
      
      option.values.forEach(value => {
        const optionElement = document.createElement('option');
        optionElement.value = value;
        optionElement.textContent = value;
        optionElement.setAttribute('data-bundleType', bundleType); 
        select.appendChild(optionElement);
             if (value == "Default Title") {
            optionElement.parentElement.setAttribute('hidden', 'hidden');
        }
      });
        select.addEventListener('change', logVariantPrice); // Add event listener
      optionDiv.appendChild(select);
    });
    currentSelectionDiv.appendChild(optionDiv);
  }
}
  logVariantPrice();
  currentSelectionDiv.parentElement.style.display = 'block';
 

}



// Function to log the selected variants' combined price 
  function logVariantPrice() {
    const selectedVariants = [];
    const bundleOption = document.querySelectorAll('.bundle-option')
    for (let i = 0; i < bundleOption.length; i++) {
      const selectedOptions = [];
      document.querySelectorAll(`select[name^="option-${i}-"]`).forEach(select => {
        selectedOptions.push(select.value);
      });

      const selectedVariant = productVariants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]); });
      if (selectedVariant) {
        selectedVariants.push(selectedVariant); 
      } 
    }

    

bundleOption.forEach(bunleopt => {
    const optionBundleType = bunleopt.querySelector("option").dataset.bundletype;

    const totalPrice = (selectedVariants.reduce((sum, variant) => sum + parseFloat(variant.price), 0) / 100).toFixed(2);
    // const totalCompareAtPrice = (selectedVariants.reduce((sum, variant) => sum + parseFloat(variant.compare_at_price), 0) / 100).toFixed(2);
      var totalCompareAtPrice = (selectedVariants.reduce((sum, variant) => sum + parseFloat(variant.compare_at_price), 0) / 100).toFixed(2);
      if (isNaN(totalCompareAtPrice)) {
          totalCompareAtPrice = totalPrice;
      }
    
    let discountedPrice;
    let discountedPriceSaved;
    if (optionBundleType === "duo") {
        discountedPrice = (totalPrice * (1 - duoDiscount)).toFixed(2); // 15% off
        discountedPriceSaved = (totalPrice * duoDiscount).toFixed(2); // saved on -15% 
        percentPrice = (((totalCompareAtPrice - discountedPrice)*100)/totalCompareAtPrice).toFixed(0);
      
       arkRegPrice.innerHTML = `${totalCompareAtPrice} €`;
       arkSalePrice.innerHTML = ` ${discountedPrice} €`;
       klarnaset.innerHTML = `${(discountedPrice / 3).toFixed(2)} €`;
       savePrice.innerHTML = ` -${percentPrice}%`;
       savePrice.classList.remove("hidden");
      
    } else if (optionBundleType === "trio") {
        discountedPrice = (totalPrice * (1 - trioDiscount)).toFixed(2); // 20% off
        discountedPriceSaved = (totalPrice * trioDiscount).toFixed(2); // saved on - 20% off
        percentPrice = (((totalCompareAtPrice - discountedPrice)*100)/totalCompareAtPrice).toFixed(0);
      
       arkRegPrice.innerHTML = `${totalCompareAtPrice} €`;
       arkSalePrice.innerHTML = ` ${discountedPrice} €`;
       klarnaset.innerHTML = `${(discountedPrice / 3).toFixed(2)} €`;
       savePrice.innerHTML = ` -${percentPrice}%`;
       savePrice.classList.remove("hidden");

      
    } else {
        discountedPrice = totalPrice;
        arkRegPrice.innerHTML = `${totalCompareAtPrice} €`;
        arkSalePrice.innerHTML = ` ${totalPrice} €`;
        klarnaset.innerHTML = `${(totalPrice / 3).toFixed(2)} €`;
      console.log("123");

        // discountedPriceSaved = 0;
    }

    document.querySelector(`.bundleCost[data-bundletype='${optionBundleType}']`).innerHTML = ` ${discountedPrice} €`;
    document.querySelector(`.bundleCost-saved[data-bundletype='${optionBundleType}']`).innerHTML = `Économisez en + : ${discountedPriceSaved} €`;
    document.querySelector(`.bundleCompareAtCost[data-bundletype='${optionBundleType}']`).innerHTML = `${totalCompareAtPrice} €`;


selectedVariants.forEach(variant => {
  if (variant.available) {
    addToCartButton.disabled = false;
  } else {
    document.querySelector(`.bundleCost-saved[data-bundletype='${optionBundleType}']`).innerHTML = `COMBO OUT OF STOCK`;
    addToCartButton.disabled = true;
  }
});
  

});


  }


  bundleOptions.addEventListener('change', function(e) {

  if (e.target.name === 'bundle-type') {
    renderOptions(e.target.value);
  }
});





function addToCart(variantId, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {

    // Update cart UI
    updateCartUI();
    // Add 'active' class to the drawer
    document.querySelector('.drawer.animate').classList.remove('is-empty');
    document.querySelector('.drawer.animate').classList.add('active');
    document.querySelector('body').classList.add('overflow-hidden')
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  });
}
  
  
function updateCartUI() {
  fetch('/cart')
    .then(response => response.text())
    .then(data => {
      // Create a temporary DOM element to parse the fetched HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data;

      // Extract the new content from the fetched HTML
      const newContent = tempDiv.querySelector('.drawer__inner') ? tempDiv.querySelector('.drawer__inner').innerHTML : '';

      // Update the target element with the new content
      const cartDrawer = document.querySelector('.drawer__inner');
      if (cartDrawer) {
        cartDrawer.innerHTML = newContent;
      } else {
        console.error('CartDrawer element not found');
      }
    })
    .catch(error => {
      console.error('Error refreshing cart:', error);
    });
}

addToCartButton.addEventListener('click', async function() {
  const selectedOptions = [];
  document.querySelectorAll('.bundle-option').forEach(optionDiv => {

    const options = {};
    optionDiv.querySelectorAll('select').forEach(select => {
      options[select.name] = select.value;
    });
    selectedOptions.push(options);
  });

  for (const optionSet of selectedOptions) {
    const variant = productVariants.find(variant => {
      return variant.options.every((option, index) => option === optionSet[`option-${selectedOptions.indexOf(optionSet)}-${productOptions[index].name}`]);
    });

    if (variant) {
      await addToCart(variant.id, 1);
    }
  }
});




  }); // DOM Loaded closing
